import classNames from 'classnames';

export interface SidebarDividerProps {
  className?: string;
}

export const SidebarDivider = ({ className }: SidebarDividerProps) => (
  <hr className={classNames('border-ds-border-soft-2 opacity-[0.32] w-full', className)} />
);
